import make, { Enum } from '@xaamin/enum';

class RecepcionStatus extends Enum {

  name = 'RecepcionStatus';

  enum = {
    'invalid': false,
    'valid': true,
  }

}

export default make(RecepcionStatus);